export class Availability {
  always: boolean;
  now: boolean;
  description: string;
  startdate: string; // Datetime in "yyyymmdd" format.
  enddate: string; // Datetime in "yyyymmdd" format.
}
